import React, { ReactElement } from 'react'
import { observer } from 'mobx-react'

import { APIStatus } from '@flowwai-frontend/shared/api-common'
import { Checkbox, CheckboxGroup } from '@flowwai-frontend/design-system'
import {
   LoadingWrapper,
   useAutoScrolling
} from '@flowwai-frontend/shared/common-components'
import { useAppTheme } from '@flowwai-frontend/bps-officer-web/style-guide'

import GSFieldsLoadingView from '../../controllers/GlobalSearchContentController/components/GSLoadingView'
import { GSFieldType } from '../../types'

import { gsFieldClassName, gsFieldsContainerClassName } from './styles'

import './index.css'

interface Props {
   fields: GSFieldType[]
   setSelectedFieldIds: (ids: string[]) => void
   selectedFieldIds: string[]
   apiStatus: APIStatus
   apiError: Error | null

   scrollContainerClassName?: string
}

const GSFieldsSelection = (props: Props) => {
   const {
      fields,
      setSelectedFieldIds,
      selectedFieldIds,
      apiStatus,
      apiError,

      scrollContainerClassName
   } = props

   const { theme } = useAppTheme()
   const { gsFieldBorderColor } = theme.globalSearch.searchModal

   const autoScrolling = useAutoScrolling()

   const renderFields = (): ReactElement => (
      <LoadingWrapper
         apiStatus={apiStatus}
         apiError={apiError}
         renderFailureView={() => <></>}
         renderLoadingView={() => <GSFieldsLoadingView />}
         containerClassName='w-fitContent h-[24px]'
      >
         <CheckboxGroup
            size='Small'
            onChange={setSelectedFieldIds}
            axis='horizontal'
            value={selectedFieldIds}
            showLabel={false}
         >
            {fields.map(field => {
               const isLastCheckBoxItem =
                  fields.indexOf(field) === fields.length - 1

               return (
                  <Checkbox
                     value={field.fieldId}
                     key={field.fieldId}
                     hiddenInputContainerClass={'hidden-checkbox-class-name'}
                     className={` ${gsFieldBorderColor} ${gsFieldClassName} ${
                        isLastCheckBoxItem ? '!mr-2' : '!mr-[0px]'
                     } `}
                  >
                     <span className='truncate'>{field.name}</span>
                  </Checkbox>
               )
            })}
         </CheckboxGroup>
      </LoadingWrapper>
   )

   return (
      <div className='flex flex-grow overflow-hidden min-h-[41px]'>
         <div
            className={`${gsFieldsContainerClassName} ${scrollContainerClassName} ${autoScrolling.className}`}
            ref={autoScrolling.ref}
         >
            {renderFields()}
         </div>
      </div>
   )
}

export default observer(GSFieldsSelection)
